import React, { Suspense, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Loading from "../Components/Loading/Loading";
import PageNotFound from "../Components/PageNotFound/PageNotFound";
import { updateOnlineStatus } from "../Components/Common/comman";

const CandidateDashboard = React.lazy(() =>
  import("../Components/Candidate/CandidateDashboard/CandidateDashboard")
);
const MyResumes = React.lazy(() =>
  import("../Components/Candidate/MyResumes/MyResumes")
);
const ResumeCreate = React.lazy(() =>
  import("../Components/Candidate/ResumeCreate/ResumeCreate")
);
const ConnectHistory = React.lazy(() =>
  import("../Components/Candidate/ConnectHistoryAndBidHistory/ConnectHistory")
);
const BidHistory = React.lazy(() =>
  import("../Components/Candidate/ConnectHistoryAndBidHistory/BidHistory")
);
// user routes
const Notification = React.lazy(() =>
  import("../Components/User/Notification/Notification")
);
const GetInTouch = React.lazy(() =>
  import("../Components/Public/GetInTouch/GetInTouch")
);
const Profile = React.lazy(() => import("../Components/User/Profile/Profile"));
const MoreDetails = React.lazy(() =>
  import("../Components/MoreDetails/MoreDetails")
);
const Chat = React.lazy(() => import("../Components/User/Chat/Chat"));
const ProjectPublicDetail = React.lazy(() =>
  import("../Components/Employer/ProjectPublicDetail")
);

const ResumePublicView = React.lazy(() =>
  import("../Components/Candidate/ResumePublicView")
);
const CandidateRoutes = (props) => {
  useEffect(() => {
    updateOnlineStatus(props);
    const interval = setInterval(() => updateOnlineStatus(props), 1000 * 60);
    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<CandidateDashboard {...props} />} />{" "}
        <Route path="/my-resumes" element={<MyResumes {...props} />} />{" "}
        <Route
          path="/candidate/create-resume"
          element={<ResumeCreate {...props} />}
        />{" "}
        <Route
          path="/candidate/connect-history"
          element={<ConnectHistory {...props} />}
        />{" "}
        <Route
          path="candidate/bid-history"
          element={<BidHistory {...props} />}
        />
        {/*========== user and public url======== */}
        <Route
          path="/user/notifications"
          element={<Notification {...props} />}
        />
        <Route path="/get-in-touch" element={<GetInTouch {...props} />} />
        <Route path="/user/profile/:id/*" element={<Profile {...props} />} />
        <Route path="/more-details" element={<MoreDetails {...props} />} />
        <Route path="/user/chat" element={<Chat {...props} />} />
        <Route
          path="/public-view/:userId/:resumeId/*"
          element={<ResumePublicView {...props} />}
        />
        <Route
          path="/project-view/:userId/:projectId/*"
          element={<ProjectPublicDetail {...props} />}
        />
        <Route path="/employer/*" element={<Navigate to="/" />} />
        <Route path="*" element={<PageNotFound {...props} />} />
      </Routes>
    </Suspense>
  );
};

export default CandidateRoutes;
